<div *ngIf="isSeePriceInCart && pricingInfo" class="price-text">
	See Price In Cart
</div>
<div *ngIf="!isSeePriceInCart && pricingInfo" [ngClass]="{'clearance': isClearance}" class="price-text">
	<ng-container *ngIf="pricingInfo.minofferprice">
		{{pricingInfo.minofferprice | currency }}<span *ngIf="pricingInfo.maxofferprice !== pricingInfo.minofferprice"> - {{pricingInfo.maxofferprice | currency }}</span>
	</ng-container>
	<!-- Favorites sku product card pricing -->
	<ng-container *ngIf="!pricingInfo.minofferprice">
		{{pricingInfo.offerPrice | currency }}
	</ng-container>
</div>
